// extracted by mini-css-extract-plugin
export default {"errorBlock":"errorBlock_errorBlock__F5zQS","errorBlock_show":"errorBlock_errorBlock_show__qj21N"};